<template>
<div>
  <columns>
    <column>
      <h4 class="is-size-5">Environment</h4>
    </column>
  </columns>
  <div class="is-flex justify-between mb" v-for="attribute in environmentAttributes" :key="attribute.id">
    <p>
      <span class="has-text-weight-bold">{{ attribute.type.title }} </span>
    </p>
    <p>
      <span v-if="attribute.latest_unresolved_finding" class="tag is-danger">
        <icon icon="exclamation-triangle"/>
      </span>
      {{ castValue(attribute) }}
    </p>
  </div>
</div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {

  methods: {
    castValue(attribute) {
      return this.$castTo(attribute)
    }
  },
  
  computed: {
    ...mapGetters('environment', [
      'environmentAttributes'
    ])
  }

}
</script>